import {uniqueId} from 'lodash';

export default function getUniqueKeyForCard(card, isPreviewPage) {
  return (isPreviewPage) ? uniqueId() : card.id;
}
